import {
    useState,
    useMemo,
    useEffect,
} from 'react'
import {
    useParams, useNavigate,
} from 'react-router-dom'
import last from 'lodash/last'
import isEqual from 'lodash/isEqual'

import {
    LoggerResponse,
} from '../Loggers.types'

import useGetLoggersByLoggerNumbers from './useGetLoggersByLoggerNumbers'

const mapByLoggerNumber = ({
    loggerNumber,
}) => { return loggerNumber }

export default () => {
    const navigate = useNavigate()
    const [
        parsedUrl,
        setParsedUrl,
    ] = useState(false)

    const [
        loggersToRequest,
        setLoggersToRequest,
    ] = useState([])

    const {
        otherLoggersNumbers,
    } = useParams()

    useEffect(() => {
        const urlLoggerNumbers = otherLoggersNumbers?.split(',') || []

        if (!parsedUrl && urlLoggerNumbers.length) {
            setLoggersToRequest(urlLoggerNumbers)
        }
        setParsedUrl(true)
    }, [
        otherLoggersNumbers,
        parsedUrl,
    ])

    const [
        otherLoggers,
        setOtherLoggers,
    ] = useState<LoggerResponse[]>([])

    const onOtherLoggersChange = (loggers) => {
        const selectedLoggerNumbers = loggers?.map(mapByLoggerNumber)

        if (!isEqual(selectedLoggerNumbers, otherLoggersNumbers)) {
            navigate(`.${otherLoggersNumbers ? '.' : ''}/${selectedLoggerNumbers}`, {
                replace: true,
                relative: 'path',
            })
        }

        if (selectedLoggerNumbers?.length > otherLoggers.length) {
            const loggerNumber = last(selectedLoggerNumbers)

            setLoggersToRequest([loggerNumber])
        } else {
            setLoggersToRequest([])
            setOtherLoggers(
                [...otherLoggers.filter((
                    {
                        loggerNumber,
                    },
                ) => {
                    return selectedLoggerNumbers?.includes(loggerNumber)
                })],
            )
        }
    }

    const {
        response, isDataReady,
    } = useGetLoggersByLoggerNumbers(loggersToRequest)

    const otherLoggersResponse = useMemo(() => {
        if (isDataReady) {
            return response.reduce((acc, {
                data,
            }) => {
                return {
                    otherLoggersData: [
                        ...acc.otherLoggersData,
                        {
                            ...data,
                            value: data.loggerNumber,
                            label: data.loggerNumber,
                        },
                    ],
                    responsedLoggerNumbers: [
                        ...acc.responsedLoggerNumbers,
                        data.loggerNumber,
                    ],
                }
            }, {
                otherLoggersData: [],
                responsedLoggerNumbers: [],
            })
        }
        return null
    }, [
        response,
        isDataReady,
    ])

    useEffect(() => {
        if (otherLoggersResponse) {
            const {
                otherLoggersData,
                responsedLoggerNumbers,
            } = otherLoggersResponse as {
                otherLoggersData: LoggerResponse[],
                responsedLoggerNumbers: string[]
            }

            if (loggersToRequest.length && isEqual(loggersToRequest, responsedLoggerNumbers)) {
                setOtherLoggers([
                    ...otherLoggers,
                    ...otherLoggersData,
                ])
                setLoggersToRequest([])
            }
        }
    }, [
        otherLoggers,
        loggersToRequest,
        otherLoggersResponse,
    ])

    return {
        onOtherLoggersChange,
        otherLoggers,
    }
}
